import { api } from '@marine/api-client/api';
import type { PreferencesTree } from '@/types/preferences';

/**
 * Platform UI is served from the bare domain; tenant UI from any subdomain.
 * Platform preferences live on `User` (landlord DB) via /api/preferences.
 * Tenant preferences live on `Employee` (tenant DB) via /api/preferences.
 */
function isTenantContext(): boolean {
  if (typeof window === 'undefined') return false;
  const host = window.location.hostname;
  const parts = host.split('.');
  // e.g. tenant.dms44.com (3 parts) = tenant; dms44.com (2 parts) = platform.
  // For localhost dev (e.g. tenant.marine-dms.local), same shape applies.
  return parts.length >= 3;
}

function endpoint(): string {
  return isTenantContext() ? '/api/preferences' : '/api/preferences';
}

export async function patchPreference(path: string, value: unknown): Promise<PreferencesTree> {
  return api.patchOne<PreferencesTree>(endpoint(), { path, value });
}

export async function deletePreference(path: string): Promise<PreferencesTree> {
  // `api.deleteOne` doesn't accept a body; use the raw axios wrapper.
  const response = await api.delete<{ data: PreferencesTree }>(endpoint(), {
    data: { path },
  });
  return response.data.data;
}
